export const contact = {
  name: 'Tony Rumor',
  company: 'Passion Rénovation',
  email: 'passion.renovation@gmail.com',
  phoneLabel: '06 50 32 14 86',
  phoneHref: 'tel:+33650321486',
}
